module.exports = __webpack_public_path__ + "img/cpany17.aaab79fb.png";